// components/NotificationsDialog.jsx
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Stack,
  Typography,
  Card,
  CardContent,
  Badge
} from '@mui/material';
import { Notifications } from '@mui/icons-material';

const NotificationsDialog = ({
  open,
  onClose,
  notifications,
  isConnected,
  onClearNotifications,
  onViewMessage
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { 
          borderRadius: 2,
          backgroundColor: isConnected ? 'rgba(0,0,0,0.9)' : undefined,
          color: isConnected ? 'white' : undefined,
        }
      }}
    >
      <DialogTitle>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Notifications />
          消息通知
          <Badge badgeContent={notifications.length} color="error" />
        </Stack>
      </DialogTitle>
      <DialogContent>
        {notifications.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 3 }}>
            <Typography 
              color={isConnected ? 'rgba(255,255,255,0.7)' : 'text.secondary'}
            >
              暫無新通知
            </Typography>
          </Box>
        ) : (
          <Stack spacing={2}>
            {notifications.slice(0, 10).map((notification, index) => (
              <Card 
                key={index} 
                sx={{ 
                  backgroundColor: isConnected 
                    ? 'rgba(25,118,210,0.3)' 
                    : 'rgba(25,118,210,0.1)',
                  borderLeft: `4px solid ${isConnected ? '#1976d2' : '#1976d2'}`,
                  borderRadius: 1
                }}
              >
                <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                  <Typography 
                    variant="subtitle2" 
                    gutterBottom
                    sx={{ color: isConnected ? 'white' : 'text.primary' }}
                  >
                    <strong>@{notification.from_user}</strong> 在消息中提到了你
                  </Typography>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      color: isConnected ? 'rgba(255,255,255,0.8)' : 'text.secondary' 
                    }} 
                    gutterBottom
                  >
                    {notification.message_text}
                  </Typography>
                  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mt: 1 }}>
                    <Typography 
                      variant="caption" 
                      sx={{ 
                        color: isConnected ? 'rgba(255,255,255,0.6)' : 'text.secondary' 
                      }}
                    >
                      {new Date(notification.created_at).toLocaleString('zh-TW')}
                    </Typography>
                    <Button
                      size="small"
                      onClick={() => {
                        onViewMessage(notification.message_id);
                        onClose();
                      }}
                      sx={{
                        color: isConnected ? '#ffd700' : 'primary.main',
                        '&:hover': {
                          backgroundColor: isConnected ? 'rgba(255,215,0,0.1)' : undefined,
                        }
                      }}
                    >
                      查看消息
                    </Button>
                  </Stack>
                </CardContent>
              </Card>
            ))}
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        {notifications.length > 0 && (
          <Button 
            onClick={onClearNotifications} 
            color="error"
            sx={{
              color: isConnected ? '#ff6b6b' : undefined,
            }}
          >
            清空通知
          </Button>
        )}
        <Button 
          onClick={onClose}
          sx={{
            color: isConnected ? 'white' : undefined,
          }}
        >
          關閉
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotificationsDialog;